import { StatusOption } from '../../utils'

export enum AffectedStaffStatusEnum {
  PENDING = 'PENDING',
  AFFECTED = 'AFFECTED',
  CANCELLED = 'CANCELLED'
}

export enum TravelExpensesStatusEnum {
  PENDING = 'PENDING',
  RECEIVED = 'RECEIVED',
  VALIDATED = 'VALIDATED'
}

export const travelExpensesStatusEnumMapping: Record<TravelExpensesStatusEnum, StatusOption> = {
  PENDING: {
    label: 'En attente',
    variant: 'warning'
  },
  RECEIVED: {
    label: 'Reçu',
    variant: 'blue'
  },
  VALIDATED: {
    label: 'Validée',
    variant: 'success'
  }
}
